export default {
  update() {
    setTimeout(() => {
      // 聚焦元素
      // if (el.offsetParent != null) {
      //     el.getElementsByTagName('input')[0].focus();
      // }
    });
  }
};
